//
//component
import { App, Button, Form, Modal } from "antd";
//redux
//selector
//actions
import { forgetPassword } from "store/user/auth/user_auth.action";
//utils
//hook
import { useDispatch } from "react-redux";
//str

const ForgetPassword = () => {
  // -------------------------- VAR -----------------------------
  const form = Form.useFormInstance();
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const handleClick = () => {
    const values = form.getFieldsValue();
    const email = values.email;
    dispatch(
      forgetPassword({ email }, (res) => {
        const status = res.status;
        if (status === 200) {
          message.success("Đã gửi email đổi mật khẩu đến email");
        } else if (status === 500) {
          message.error(res.data);
        }
      }),
    );
  };

  const forgetInfo = () => {
    Modal.info({
      title: "Tính năng đang phát triển, xin vui lòng liên hệ admin",
    });
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Button type="link" onClick={forgetInfo}>
      Quên mật khẩu?
    </Button>
  );
};
export default ForgetPassword;
